import { AllowChangeGrid } from '../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import {
  OrderProductForGridContainer,
  OrderProductForGridContainerTransformer,
} from '../../../../../orders/products/product/grid/components/orderProductGrid/components/grid/types/orderProductGridContainer.types';
import { AvailabilityEnum } from '../../../../../products/ProductTypes';
import { CatalogListCombination } from './catalogListCombinations.utils';
import { resolveAllowChangeGrid } from './catalogListGridDisable.utils';

interface CatalogListRowProductColor {
  productId: string;
  productColorId: string;
  allowChangeImmediateGrid?: AllowChangeGrid;
  allowChangePreOrderGrid?: AllowChangeGrid;
}

export interface BuildCatalogListRowProductParams {
  productColor: CatalogListRowProductColor;
  combination?: CatalogListCombination;
  orderId?: string;
}

export const buildCatalogListRowProduct = ({
  productColor,
  combination,
  orderId,
}: BuildCatalogListRowProductParams): OrderProductForGridContainer =>
  OrderProductForGridContainerTransformer.fromCatalog({
    orderId,
    productId: productColor.productId,
    productColorId: productColor.productColorId,
    availability: combination?.availability ?? AvailabilityEnum.EMPTY,
    deliveryWindowId: combination?.deliveryWindow?.id,
    combinationKey: combination?.combinationKey ?? '',
    allowChangeImmediateGrid: resolveAllowChangeGrid(productColor.allowChangeImmediateGrid),
    allowChangePreOrderGrid: resolveAllowChangeGrid(productColor.allowChangePreOrderGrid),
  });
